import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconBin.module.css';

const IconBin = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.36133C10.8954 2.36133 10 3.25676 10 4.36133H2V5.86133H22V4.36133H14C14 3.25676 13.1046 2.36133 12 2.36133Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3108 7.36133H3.68933L4.87764 22.6113H19.1224L20.3108 7.36133ZM6.26531 21.1113L5.31076 8.86133H18.6893L17.7348 21.1113H12.75V11.3613H11.25V21.1113H6.26531Z"
        fill="black"
      />
    </svg>
  );
};

IconBin.defaultProps = { className: null };

IconBin.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconBin;
